import { observable, action } from "mobx";
import { post, get, deleted, put } from "../services/ajax.service";

class BrokerAdminStore {
  @observable brokerAdmin = [];

  @observable limit = 10;
  @observable tiles = 0;
  @observable permissioncheck = {
      UserScreen: {},
      UserReport:{}
  };
  @observable url = "/api/v1/brokeradminactions";
  
  @action deleteUser = (id) => {
    var filtered = this.brokerAdmin.filter(user => user.id !== id);
    this.brokerAdmin = filtered;
  }

  @action get_permissions = async (id) => {
    var response = await get(`${this.url}/getpermissions/${id}`);
    this.permissioncheck = response.data
    
    return response.data;
  }

  @action getAll = async data => {
    this.brokerAdmin = [];
    let brokeradmin = await get(
      `${this.url}/getAll?limit=${this.limit}&&offset=${data.offset}&&search=${data.search}&&attr=${data.attr}`
    );
    this.brokerAdmin = brokeradmin.data.rows;
    let count = parseInt(brokeradmin.data.count);
    this.tiles =
      count % this.limit == 0
        ? parseInt(count / this.limit)
        : parseInt(count / this.limit) + 1;
  };

}

export default BrokerAdminStore;
